"use client";

import { motion } from "framer-motion";
import { EASE } from "@/lib/motion";
import { PageHero } from "@/components/shared/PageHero";
import { Icon } from "@/components/ui/Icon";

export type DocSection = { h: string; p: string };

/* One template behind every long-form page — legal, support, about and blog
   are all a document block drawn through here, so they stay visually
   identical to each other. The footer is the page's, not this template's. */
export function DocPage({ title, intro, sections }: { title: string; intro: string; sections: DocSection[] }) {
  return (
    <>
      <PageHero size="lg" title={title} body={intro || undefined} />

      {sections.length > 0 && (
        <div className="mx-auto grid max-w-[1096px] gap-[16px] px-[24px] pb-[64px] sm:grid-cols-2 lg:px-[48px]">
          {sections.map((s, i) => (
            <motion.section
              key={s.h}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, ease: EASE, delay: i * 0.05 }}
              className="flex flex-col gap-[8px] rounded-2xl bg-elevation-1 p-[16px]"
            >
              <div className="flex items-center gap-[8px]">
                <Icon name="check" size={22} className="shrink-0 text-brand-bold" />
                <h2 className="text-[14px] font-bold leading-[1.6]">{s.h}</h2>
              </div>
              <p className="text-[14px] font-normal leading-[1.6] text-fg-subtle">{s.p}</p>
            </motion.section>
          ))}
        </div>
      )}
    </>
  );
}
